import { useQueryWithUserId } from '@northladder/services';

import { INV_MGMT_SERVICE_API } from '../../../InventoryManagementClient';

/**
 * This is to track Transfer Details
 */
export const TRAY_DETAILS_QUERY_KEY = 'tray-details-query-key';

/**
 * This hook fetches the inbound details.
 */
export const useFetchTrayDetails = (trayNumber: string) => {
  const { data, isError, error, isPending, refetch } = useQueryWithUserId({
    queryKey: [TRAY_DETAILS_QUERY_KEY, trayNumber],
    networkMode: 'always',
    queryFn: () => INV_MGMT_SERVICE_API.getTrayInfo(trayNumber),
  });

  return {
    data,
    error,
    isError,
    isPending,
    refetch,
  };
};
